import { useQueryClient } from "@tanstack/react-query";
import { ExtractRouteParams } from "react-router";
import { useHistory, useParams } from "react-router-dom";

import { useAuth } from "~components";
import { AUTH_URLS, createTimesheetUrl, PayCodeEditView } from "~pages";

import { useTimesheetSubmission } from "./hooks";
import type { PayCode } from "./utils";

/**
 * Page | PayCode Details
 *
 * Renders a page to create a new PAYCODE timesheet entry.
 */
export function PayCodeDetailsPage() {
  const { weekId } =
    useParams<ExtractRouteParams<typeof AUTH_URLS.timesheetCreatePaycode, string>>();
  const history = useHistory();
  const queryClient = useQueryClient();
  const { userInfo } = useAuth();

  const {
    mutate: submitTimesheet,
    isPending: isSubmitting,
    error: submitError,
  } = useTimesheetSubmission(weekId || "");

  function onSubmit(formData: PayCode) {
    // Transform the form data to match the API contract
    const timesheetEntry = {
      timesheet: [
        {
          type: "PAYCODE" as const,
          action: "CREATE" as const,
          payCode:
            formData.payCode === "Sick" && userInfo.address?.state === "NJ"
              ? "NJSIC"
              : formData.payCode!,
          date: formData.date!.toUTC().toISODate(),
          durationInMinutes: formData.durationInMinutes!,
        },
      ],
    };

    submitTimesheet(timesheetEntry, {
      onSuccess: () => {
        queryClient.removeQueries({ queryKey: ["timesheets", weekId] });
        history.push(createTimesheetUrl(weekId));
      },
      onError: (error) => {
        console.error("Failed to submit timesheet:", error);
      },
    });
  }

  return (
    <PayCodeEditView
      onSubmit={onSubmit}
      isLoading={isSubmitting}
      error={!!submitError}
      payCode={{
        type: "PAYCODE",
        id: "",
      }}
    />
  );
}
